export const creditCard = [
  '0 0 32 32',
  `<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.1333" stroke="#000" d="M27.966 5.364h-23.932c-1.469 0-2.659 1.191-2.659 2.659v15.955c0 1.469 1.19 2.659 2.659 2.659h23.932c1.469 0 2.659-1.19 2.659-2.659v-15.955c0-1.469-1.19-2.659-2.659-2.659z"></path>
  <path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.1333" stroke="#000" d="M1.375 13.341h29.25"></path>
`,
]
